/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Table_DeveloperInputs */



/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Options_Cli_Table_DeveloperInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_table_developer = /** @type {((inputs?: Options_Cli_Table_DeveloperInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Table_DeveloperInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Développeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entwickler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sviluppatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разработчик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revelador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开发者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開発者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेवलपर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desenvolvedor")
	return /** @type {LocalizedString} */ ("Developer")
});